export const city = [
  {
    _id: "6242af80e5d8858dadffa9c4",
    name: {
      _id: "6242af80e5d8858dadffa9c2",
      model: "city",
      az: "Zərdab",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:04:32.792Z",
  },
  {
    _id: "686373227c335ef304fc5554",
    name: {
      _id: "686373227c335ef304fc5552",
      model: "city",
      az: "Xankəndi",
      en: "Khankandi",
      ru: "",
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    tags: ["permission_tato"],
    createdAt: "2025-07-01T05:33:22.568Z",
    country: {
      _id: "6576bfca218ca87d4627df1d",
      name: {
        _id: "66fa522d1b2350d8cf289251",
        az: "Azərbaycan Respublikası",
        en: "Azerbaijan",
      },
    },
  },
  {
    _id: "6242af74e5d8858dadffa9ae",
    name: {
      _id: "6242af74e5d8858dadffa9ac",
      model: "city",
      az: "Zəngilan",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:04:20.790Z",
  },
  {
    _id: "686373707c335ef304fc557a",
    name: {
      _id: "686373707c335ef304fc5578",
      model: "city",
      az: "Ağdərə",
      en: "Aghdara",
      ru: "",
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    tags: ["permission_tato"],
    createdAt: "2025-07-01T05:34:40.356Z",
    country: {
      _id: "6576bfca218ca87d4627df1d",
      name: {
        _id: "66fa522d1b2350d8cf289251",
        az: "Azərbaycan Respublikası",
        en: "Azerbaijan",
      },
    },
  },
  {
    _id: "6242af66e5d8858dadffa998",
    name: {
      _id: "6242af66e5d8858dadffa996",
      model: "city",
      az: "Zaqatala",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:04:06.077Z",
  },
  {
    _id: "6242af53e5d8858dadffa982",
    name: {
      _id: "6242af53e5d8858dadffa980",
      model: "city",
      az: "Yevlax",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:03:47.382Z",
  },
  {
    _id: "6242af46e5d8858dadffa96c",
    name: {
      _id: "6242af46e5d8858dadffa96a",
      model: "city",
      az: "Yardımlı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0439e67cdb30bd4c67cf",
      name: {
        _id: "610c0439e67cdb30bd4c67ce",
        en: "Southern",
        ru: "Южный",
        az: "Cənub",
      },
    },
    region: {
      _id: "610c03e5e67cdb30bd4c67c3",
      name: {
        _id: "610c03e5e67cdb30bd4c67c2",
        en: 'South: "Gateway to the subtropics"',
        ru: "Юг: «Ворота в субтропики»",
        az: 'Cənub: "Subtropiklərə qaçış"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:03:34.118Z",
  },
  {
    _id: "6242af39e5d8858dadffa956",
    name: {
      _id: "6242af39e5d8858dadffa954",
      model: "city",
      az: "Xocavənd",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:03:21.451Z",
  },
  {
    _id: "6242af2de5d8858dadffa940",
    name: {
      _id: "6242af2de5d8858dadffa93e",
      model: "city",
      az: "Xocalı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:03:09.090Z",
  },
  {
    _id: "6242af12e5d8858dadffa92a",
    name: {
      _id: "6242af12e5d8858dadffa928",
      model: "city",
      az: "Xızı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d0e67cdb30bd4c67bb",
      name: {
        _id: "610c03d0e67cdb30bd4c67ba",
        en: 'Baku-Abseheron: "Harmony of contrasts"',
        ru: "Баку-Абшехерон: «Гармония контрастов»",
        az: 'Bakı-Abşeron: "Təzadlar harmoniyası"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:02:42.166Z",
  },
  {
    _id: "6242aefee5d8858dadffa914",
    name: {
      _id: "6242aefee5d8858dadffa912",
      model: "city",
      az: "Xaçmaz",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d5e67cdb30bd4c67bd",
      name: {
        _id: "610c03d5e67cdb30bd4c67bc",
        en: 'North: "Between mountain and sea"',
        ru: "Север: «Между горой и морем».",
        az: 'Şimal: "Dağ və dəniz arasında"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:02:22.149Z",
  },
  {
    _id: "6242aef0e5d8858dadffa8fe",
    name: {
      _id: "6242aef0e5d8858dadffa8fc",
      model: "city",
      az: "Ucar",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:02:08.695Z",
  },
  {
    _id: "6242aedbe5d8858dadffa8e8",
    name: {
      _id: "6242aedbe5d8858dadffa8e6",
      model: "city",
      az: "Tovuz",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:01:47.136Z",
  },
  {
    _id: "6242aecce5d8858dadffa8d2",
    name: {
      _id: "6242aecce5d8858dadffa8d0",
      model: "city",
      az: "Tərtər",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:01:32.350Z",
  },
  {
    _id: "6242aebfe5d8858dadffa8bc",
    name: {
      _id: "6242aebfe5d8858dadffa8ba",
      model: "city",
      az: "Şuşa",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:01:19.101Z",
  },
  {
    _id: "6242aeaae5d8858dadffa8a6",
    name: {
      _id: "6242aeaae5d8858dadffa8a4",
      model: "city",
      az: "Sumqayit",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d0e67cdb30bd4c67bb",
      name: {
        _id: "610c03d0e67cdb30bd4c67ba",
        en: 'Baku-Abseheron: "Harmony of contrasts"',
        ru: "Баку-Абшехерон: «Гармония контрастов»",
        az: 'Bakı-Abşeron: "Təzadlar harmoniyası"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:00:58.031Z",
  },
  {
    _id: "6242ae9de5d8858dadffa890",
    name: {
      _id: "6242ae9de5d8858dadffa88e",
      model: "city",
      az: "Siyəzən",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d5e67cdb30bd4c67bd",
      name: {
        _id: "610c03d5e67cdb30bd4c67bc",
        en: 'North: "Between mountain and sea"',
        ru: "Север: «Между горой и морем».",
        az: 'Şimal: "Dağ və dəniz arasında"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:00:45.353Z",
  },
  {
    _id: "6242ae91e5d8858dadffa87a",
    name: {
      _id: "6242ae91e5d8858dadffa878",
      model: "city",
      az: "Şirvan",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:00:33.317Z",
  },
  {
    _id: "6242ae7be5d8858dadffa864",
    name: {
      _id: "6242ae7be5d8858dadffa862",
      model: "city",
      az: "Şərur",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "6242aa25e5d8858dadffa57f",
      name: {
        _id: "6242aa25e5d8858dadffa57d",
        az: "Naxçıvan",
        en: "",
        ru: "",
      },
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T07:00:11.936Z",
  },
  {
    _id: "6242ae6de5d8858dadffa84e",
    name: {
      _id: "6242ae6de5d8858dadffa84c",
      model: "city",
      az: "Şəmkir",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:59:57.361Z",
  },
  {
    _id: "6242ae60e5d8858dadffa838",
    name: {
      _id: "6242ae60e5d8858dadffa836",
      model: "city",
      az: "Şəki",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:59:44.618Z",
  },
  {
    _id: "6242ae53e5d8858dadffa822",
    name: {
      _id: "6242ae53e5d8858dadffa820",
      model: "city",
      az: "Sədərək",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "6242aa25e5d8858dadffa57f",
      name: {
        _id: "6242aa25e5d8858dadffa57d",
        az: "Naxçıvan",
        en: "",
        ru: "",
      },
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:59:31.296Z",
  },
  {
    _id: "6242ae46e5d8858dadffa80c",
    name: {
      _id: "6242ae46e5d8858dadffa80a",
      model: "city",
      az: "Samux",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:59:18.377Z",
  },
  {
    _id: "6242ae39e5d8858dadffa7f6",
    name: {
      _id: "6242ae39e5d8858dadffa7f4",
      model: "city",
      az: "Şamaxı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:59:05.724Z",
  },
  {
    _id: "6242ae2be5d8858dadffa7e0",
    name: {
      _id: "6242ae2be5d8858dadffa7de",
      model: "city",
      az: "Salyan",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:58:51.645Z",
  },
  {
    _id: "6242ae1be5d8858dadffa7ca",
    name: {
      _id: "6242ae1be5d8858dadffa7c8",
      model: "city",
      az: "Şahbuz",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "6242aa25e5d8858dadffa57f",
      name: {
        _id: "6242aa25e5d8858dadffa57d",
        az: "Naxçıvan",
        en: "",
        ru: "",
      },
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:58:35.196Z",
  },
  {
    _id: "6242ae0fe5d8858dadffa7b4",
    name: {
      _id: "6242ae0fe5d8858dadffa7b2",
      model: "city",
      az: "Şabran",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d5e67cdb30bd4c67bd",
      name: {
        _id: "610c03d5e67cdb30bd4c67bc",
        en: 'North: "Between mountain and sea"',
        ru: "Север: «Между горой и морем».",
        az: 'Şimal: "Dağ və dəniz arasında"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:58:23.613Z",
  },
  {
    _id: "6242abe0e5d8858dadffa75f",
    name: {
      _id: "6242abe0e5d8858dadffa75d",
      model: "city",
      az: "Sabirabad",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:49:04.350Z",
  },
  {
    _id: "6242abcfe5d8858dadffa749",
    name: {
      _id: "6242abcfe5d8858dadffa747",
      model: "city",
      az: "Saatlı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:48:47.620Z",
  },
  {
    _id: "6242abbde5d8858dadffa733",
    name: {
      _id: "6242abbde5d8858dadffa731",
      model: "city",
      az: "Qusar",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d5e67cdb30bd4c67bd",
      name: {
        _id: "610c03d5e67cdb30bd4c67bc",
        en: 'North: "Between mountain and sea"',
        ru: "Север: «Между горой и морем».",
        az: 'Şimal: "Dağ və dəniz arasında"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:48:29.842Z",
  },
  {
    _id: "6242abace5d8858dadffa71d",
    name: {
      _id: "6242abace5d8858dadffa71b",
      model: "city",
      az: "Qubadlı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:48:12.239Z",
  },
  {
    _id: "6242ab9ae5d8858dadffa707",
    name: {
      _id: "6242ab9ae5d8858dadffa705",
      model: "city",
      az: "Quba",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d5e67cdb30bd4c67bd",
      name: {
        _id: "610c03d5e67cdb30bd4c67bc",
        en: 'North: "Between mountain and sea"',
        ru: "Север: «Между горой и морем».",
        az: 'Şimal: "Dağ və dəniz arasında"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:47:54.391Z",
  },
  {
    _id: "6242ab8ae5d8858dadffa6f1",
    name: {
      _id: "6242ab8ae5d8858dadffa6ef",
      model: "city",
      az: "Qobustan",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:47:38.326Z",
  },
  {
    _id: "6242ab77e5d8858dadffa6db",
    name: {
      _id: "6242ab77e5d8858dadffa6d9",
      model: "city",
      az: "Qəbələ",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:47:19.355Z",
  },
  {
    _id: "6242ab61e5d8858dadffa6c5",
    name: {
      _id: "6242ab61e5d8858dadffa6c3",
      model: "city",
      az: "Qazax",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:46:57.123Z",
  },
  {
    _id: "6242ab50e5d8858dadffa6af",
    name: {
      _id: "6242ab50e5d8858dadffa6ad",
      model: "city",
      az: "Qax",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:46:40.462Z",
  },
  {
    _id: "6242ab40e5d8858dadffa699",
    name: {
      _id: "6242ab40e5d8858dadffa697",
      model: "city",
      az: "Ordubad",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "6242aa25e5d8858dadffa57f",
      name: {
        _id: "6242aa25e5d8858dadffa57d",
        az: "Naxçıvan",
        en: "",
        ru: "",
      },
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:46:24.375Z",
  },
  {
    _id: "6242ab2fe5d8858dadffa683",
    name: {
      _id: "6242ab2fe5d8858dadffa681",
      model: "city",
      az: "Oğuz",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:46:07.383Z",
  },
  {
    _id: "6242ab1ee5d8858dadffa66d",
    name: {
      _id: "6242ab1ee5d8858dadffa66b",
      model: "city",
      az: "Neftçala",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:45:50.860Z",
  },
  {
    _id: "6242ab0ce5d8858dadffa657",
    name: {
      _id: "6242ab0ce5d8858dadffa655",
      model: "city",
      az: "Naxçıvan",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "6242aa25e5d8858dadffa57f",
      name: {
        _id: "6242aa25e5d8858dadffa57d",
        az: "Naxçıvan",
        en: "",
        ru: "",
      },
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:45:32.573Z",
  },
  {
    _id: "6242aafce5d8858dadffa641",
    name: {
      _id: "6242aafce5d8858dadffa63f",
      model: "city",
      az: "Naftalan",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:45:16.675Z",
  },
  {
    _id: "6242aad6e5d8858dadffa62b",
    name: {
      _id: "6242aad6e5d8858dadffa629",
      model: "city",
      az: "Nabran",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d5e67cdb30bd4c67bd",
      name: {
        _id: "610c03d5e67cdb30bd4c67bc",
        en: 'North: "Between mountain and sea"',
        ru: "Север: «Между горой и морем».",
        az: 'Şimal: "Dağ və dəniz arasında"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:44:38.062Z",
  },
  {
    _id: "6242aabde5d8858dadffa615",
    name: {
      _id: "6242aabde5d8858dadffa613",
      model: "city",
      az: "Mingəçevir",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:44:13.510Z",
  },
  {
    _id: "6242aaa2e5d8858dadffa5ff",
    name: {
      _id: "6242aaa2e5d8858dadffa5fd",
      model: "city",
      az: "Masallı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0439e67cdb30bd4c67cf",
      name: {
        _id: "610c0439e67cdb30bd4c67ce",
        en: "Southern",
        ru: "Южный",
        az: "Cənub",
      },
    },
    region: {
      _id: "610c03e5e67cdb30bd4c67c3",
      name: {
        _id: "610c03e5e67cdb30bd4c67c2",
        en: 'South: "Gateway to the subtropics"',
        ru: "Юг: «Ворота в субтропики»",
        az: 'Cənub: "Subtropiklərə qaçış"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:43:46.268Z",
  },
  {
    _id: "6242aa8ee5d8858dadffa5e9",
    name: {
      _id: "6242aa8ee5d8858dadffa5e7",
      model: "city",
      az: "Lerik",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0439e67cdb30bd4c67cf",
      name: {
        _id: "610c0439e67cdb30bd4c67ce",
        en: "Southern",
        ru: "Южный",
        az: "Cənub",
      },
    },
    region: {
      _id: "610c03e5e67cdb30bd4c67c3",
      name: {
        _id: "610c03e5e67cdb30bd4c67c2",
        en: 'South: "Gateway to the subtropics"',
        ru: "Юг: «Ворота в субтропики»",
        az: 'Cənub: "Subtropiklərə qaçış"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:43:26.950Z",
  },
  {
    _id: "6242aa79e5d8858dadffa5d3",
    name: {
      _id: "6242aa79e5d8858dadffa5d1",
      model: "city",
      az: "Lənkəran",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0439e67cdb30bd4c67cf",
      name: {
        _id: "610c0439e67cdb30bd4c67ce",
        en: "Southern",
        ru: "Южный",
        az: "Cənub",
      },
    },
    region: {
      _id: "610c03e5e67cdb30bd4c67c3",
      name: {
        _id: "610c03e5e67cdb30bd4c67c2",
        en: 'South: "Gateway to the subtropics"',
        ru: "Юг: «Ворота в субтропики»",
        az: 'Cənub: "Subtropiklərə qaçış"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:43:05.360Z",
  },
  {
    _id: "6242aa62e5d8858dadffa5bd",
    name: {
      _id: "6242aa62e5d8858dadffa5bb",
      model: "city",
      az: "Laçın",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:42:42.659Z",
  },
  {
    _id: "6242aa4fe5d8858dadffa5a7",
    name: {
      _id: "6242aa4fe5d8858dadffa5a5",
      model: "city",
      az: "Kürdəmir",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:42:23.280Z",
  },
  {
    _id: "6242aa3be5d8858dadffa591",
    name: {
      _id: "6242aa3be5d8858dadffa58f",
      model: "city",
      az: "Kəngərli",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "6242aa25e5d8858dadffa57f",
      name: {
        _id: "6242aa25e5d8858dadffa57d",
        az: "Naxçıvan",
        en: "",
        ru: "",
      },
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:42:03.735Z",
  },
  {
    _id: "6242a9dde5d8858dadffa540",
    name: {
      _id: "6242a9dde5d8858dadffa53e",
      model: "city",
      az: "Kəlbəcər",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:40:29.300Z",
  },
  {
    _id: "6242a9b8e5d8858dadffa50a",
    name: {
      _id: "6242a9b8e5d8858dadffa508",
      model: "city",
      az: "İsmayıllı",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:39:52.430Z",
  },
  {
    _id: "6242a99fe5d8858dadffa4f4",
    name: {
      _id: "6242a99fe5d8858dadffa4f2",
      model: "city",
      az: "İmişli",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:39:27.784Z",
  },
  {
    _id: "6242a98ae5d8858dadffa4de",
    name: {
      _id: "6242a98ae5d8858dadffa4dc",
      model: "city",
      az: "Hacıqabul",
      en: "",
      ru: "",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    createdAt: "2022-03-29T06:39:06.564Z",
  },
  {
    _id: "610c0c36e67cdb30bd4c681f",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0c36e67cdb30bd4c681e",
      en: "",
      ru: "",
      model: "city",
      az: "Göygöl",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdAt: "2021-08-05T16:05:10.384Z",
  },
  {
    _id: "610c0c1ae67cdb30bd4c681d",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0c1ae67cdb30bd4c681c",
      en: "",
      ru: "",
      model: "city",
      az: "Göyçay",
    },
    corridor: {
      _id: "610c0af7e67cdb30bd4c6807",
      name: {
        _id: "610c0af7e67cdb30bd4c6806",
        en: "Central",
        ru: "Центральная",
        az: "Mərkəzi",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdAt: "2021-08-05T16:04:42.906Z",
  },
  {
    _id: "610c0c0ee67cdb30bd4c681b",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0c0ee67cdb30bd4c681a",
      en: "",
      ru: "",
      model: "city",
      az: "Goranboy",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdAt: "2021-08-05T16:04:30.322Z",
  },
  {
    _id: "610c0bfee67cdb30bd4c6819",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0bfee67cdb30bd4c6818",
      en: "",
      ru: "",
      model: "city",
      az: "Gəncə",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdAt: "2021-08-05T16:04:14.862Z",
  },
  {
    _id: "610c0baae67cdb30bd4c6817",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0baae67cdb30bd4c6816",
      en: "",
      ru: "",
      model: "city",
      az: "Gədəbəy",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdAt: "2021-08-05T16:02:50.636Z",
  },
  {
    _id: "610c0b9ce67cdb30bd4c6815",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    corridor: {
      _id: "610c0514e67cdb30bd4c67d9",
      name: {
        _id: "610c0514e67cdb30bd4c67d8",
        en: "Karabakh",
        ru: "Карабах",
        az: "Qarabağ",
      },
    },
    name: {
      _id: "610c0b9ce67cdb30bd4c6814",
      en: "",
      ru: "",
      model: "city",
      az: "Füzuli",
    },
    createdAt: "2021-08-05T16:02:36.660Z",
  },
  {
    _id: "610c0b8fe67cdb30bd4c6813",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0b8fe67cdb30bd4c6812",
      en: "",
      ru: "",
      model: "city",
      az: "Daşkəsən",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdAt: "2021-08-05T16:02:23.687Z",
  },
  {
    _id: "610c0b7ee67cdb30bd4c6811",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    name: {
      _id: "610c0b7ee67cdb30bd4c6810",
      en: "",
      ru: "",
      model: "city",
      az: "Culfa",
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdAt: "2021-08-05T16:02:06.100Z",
  },
  {
    _id: "610c0b74e67cdb30bd4c680f",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0b74e67cdb30bd4c680e",
      en: "Jalilabad",
      ru: "Джалилабад",
      model: "city",
      az: "Cəlilabad",
    },
    corridor: {
      _id: "610c0439e67cdb30bd4c67cf",
      name: {
        _id: "610c0439e67cdb30bd4c67ce",
        en: "Southern",
        ru: "Южный",
        az: "Cənub",
      },
    },
    region: {
      _id: "610c03e5e67cdb30bd4c67c3",
      name: {
        _id: "610c03e5e67cdb30bd4c67c2",
        en: 'South: "Gateway to the subtropics"',
        ru: "Юг: «Ворота в субтропики»",
        az: 'Cənub: "Subtropiklərə qaçış"',
      },
    },
    createdAt: "2021-08-05T16:01:56.021Z",
  },
  {
    _id: "610c0b5fe67cdb30bd4c680d",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0b5fe67cdb30bd4c680c",
      en: "Cabrayil",
      ru: "Джебраылъ",
      model: "city",
      az: "Cəbrayıl",
    },
    corridor: {
      _id: "610c0514e67cdb30bd4c67d9",
      name: {
        _id: "610c0514e67cdb30bd4c67d8",
        en: "Karabakh",
        ru: "Карабах",
        az: "Qarabağ",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdAt: "2021-08-05T16:01:35.022Z",
  },
  {
    _id: "610c0b4be67cdb30bd4c680b",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0b4be67cdb30bd4c680a",
      en: "Bilasuvar",
      ru: "Билясувар",
      model: "city",
      az: "Biləsuvar",
    },
    corridor: {
      _id: "610c0af7e67cdb30bd4c6807",
      name: {
        _id: "610c0af7e67cdb30bd4c6806",
        en: "Central",
        ru: "Центральная",
        az: "Mərkəzi",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdAt: "2021-08-05T16:01:15.102Z",
  },
  {
    _id: "610c0b03e67cdb30bd4c6809",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0b03e67cdb30bd4c6808",
      en: "Barda",
      ru: "Барда",
      model: "city",
      az: "Bərdə",
    },
    corridor: {
      _id: "610c0af7e67cdb30bd4c6807",
      name: {
        _id: "610c0af7e67cdb30bd4c6806",
        en: "Central",
        ru: "Центральная",
        az: "Mərkəzi",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdAt: "2021-08-05T16:00:03.350Z",
  },
  {
    _id: "610c0690e67cdb30bd4c6805",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0690e67cdb30bd4c6804",
      en: "Beylagan",
      ru: "Бейлаган",
      model: "city",
      az: "Beyləqan",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdAt: "2021-08-05T15:41:04.552Z",
  },
  {
    _id: "610c0682e67cdb30bd4c6803",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0682e67cdb30bd4c6802",
      en: "Balaken",
      ru: "Балакенъ",
      model: "city",
      az: "Balakən",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdAt: "2021-08-05T15:40:50.680Z",
  },
  {
    _id: "610c0676e67cdb30bd4c6801",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0676e67cdb30bd4c6800",
      en: "Baku",
      ru: "Баку",
      model: "city",
      az: "Bakı",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d0e67cdb30bd4c67bb",
      name: {
        _id: "610c03d0e67cdb30bd4c67ba",
        en: 'Baku-Abseheron: "Harmony of contrasts"',
        ru: "Баку-Абшехерон: «Гармония контрастов»",
        az: 'Bakı-Abşeron: "Təzadlar harmoniyası"',
      },
    },
    createdAt: "2021-08-05T15:40:38.224Z",
  },
  {
    _id: "610c0663e67cdb30bd4c67ff",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0663e67cdb30bd4c67fe",
      en: "Babek",
      ru: "Бабек",
      model: "city",
      az: "Babək",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03f1e67cdb30bd4c67c7",
      name: {
        _id: "610c03f1e67cdb30bd4c67c6",
        en: 'Nakhchivan: "Legends & landscapes"',
        ru: "Нахчыван: «Легенды и пейзажи»",
        az: 'Naxçıvan: "Əfsanələr və mənzərələr"',
      },
    },
    createdAt: "2021-08-05T15:40:19.494Z",
  },
  {
    _id: "610c0647e67cdb30bd4c67fd",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0647e67cdb30bd4c67fc",
      en: "Astara",
      ru: "Астара",
      model: "city",
      az: "Astara",
    },
    corridor: {
      _id: "610c0439e67cdb30bd4c67cf",
      name: {
        _id: "610c0439e67cdb30bd4c67ce",
        en: "Southern",
        ru: "Южный",
        az: "Cənub",
      },
    },
    region: {
      _id: "610c03e5e67cdb30bd4c67c3",
      name: {
        _id: "610c03e5e67cdb30bd4c67c2",
        en: 'South: "Gateway to the subtropics"',
        ru: "Юг: «Ворота в субтропики»",
        az: 'Cənub: "Subtropiklərə qaçış"',
      },
    },
    createdAt: "2021-08-05T15:39:51.157Z",
  },
  {
    _id: "610c063ae67cdb30bd4c67fb",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c063ae67cdb30bd4c67fa",
      en: "Aghsu",
      ru: "Агсу",
      model: "city",
      az: "Ağsu",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdAt: "2021-08-05T15:39:38.631Z",
  },
  {
    _id: "610c057ae67cdb30bd4c67df",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c057ae67cdb30bd4c67de",
      en: "Aghstafa",
      ru: "Агстафа",
      model: "city",
      az: "Ağstafa",
    },
    corridor: {
      _id: "610c0455e67cdb30bd4c67d3",
      name: {
        _id: "610c0455e67cdb30bd4c67d2",
        en: "Western",
        ru: "Западный",
        az: "Qərb",
      },
    },
    region: {
      _id: "610c03eae67cdb30bd4c67c5",
      name: {
        _id: "610c03eae67cdb30bd4c67c4",
        en: 'West: "History and heritage"',
        ru: "Запад: «История и наследие»",
        az: 'Qərb: "Tarix və irs"',
      },
    },
    createdAt: "2021-08-05T15:36:26.050Z",
  },
  {
    _id: "610c055de67cdb30bd4c67dd",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c055de67cdb30bd4c67dc",
      en: "Aghdash",
      ru: "Агдаш",
      model: "city",
      az: "Ağdaş",
    },
    corridor: {
      _id: "610c0434e67cdb30bd4c67cd",
      name: {
        _id: "610c0434e67cdb30bd4c67cc",
        en: "North-western",
        ru: "Северо-Запад",
        az: "Şimal-qərb",
      },
    },
    region: {
      _id: "610c03dbe67cdb30bd4c67bf",
      name: {
        _id: "610c03dbe67cdb30bd4c67be",
        en: 'North-west: "Spirit of the Silk Road"',
        ru: "Северо-запад: «Дух Шелкового пути»",
        az: 'Şimal-qərb: "İpək Yolunun Ruhu"',
      },
    },
    createdAt: "2021-08-05T15:35:57.568Z",
  },
  {
    _id: "610c0546e67cdb30bd4c67db",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c0546e67cdb30bd4c67da",
      en: "Aghdam",
      ru: "Агдам",
      model: "city",
      az: "Ağdam",
    },
    corridor: {
      _id: "610c0514e67cdb30bd4c67d9",
      name: {
        _id: "610c0514e67cdb30bd4c67d8",
        en: "Karabakh",
        ru: "Карабах",
        az: "Qarabağ",
      },
    },
    region: {
      _id: "610c03f8e67cdb30bd4c67c9",
      name: {
        _id: "610c03f8e67cdb30bd4c67c8",
        en: 'Karabakh: "Authentic adventures"',
        ru: "Карабах: «Настоящие приключения»",
        az: 'Qarabağ: "Əsl macəralar"',
      },
    },
    createdAt: "2021-08-05T15:35:34.691Z",
  },
  {
    _id: "610c04f0e67cdb30bd4c67d7",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c04f0e67cdb30bd4c67d6",
      en: "Agjabadi",
      ru: "Агджабади",
      model: "city",
      az: "Ağcabədi",
    },
    corridor: {
      _id: "610c043fe67cdb30bd4c67d1",
      name: {
        _id: "610c043fe67cdb30bd4c67d0",
        en: "South-western",
        ru: "Юго-западный",
        az: "Cənub-qərb",
      },
    },
    region: {
      _id: "610c03e0e67cdb30bd4c67c1",
      name: {
        _id: "610c03e0e67cdb30bd4c67c0",
        en: 'Central: "Through the plains"',
        ru: "Центральная: «По равнинам».",
        az: 'Mərkəzi: "Düzənliklər boyunca"',
      },
    },
    createdAt: "2021-08-05T15:34:08.479Z",
  },
  {
    _id: "610c04bbe67cdb30bd4c67d5",
    createdBy: {
      _id: "5f882e6449cb2c2090a1b2f5",
      username: "admin",
    },
    name: {
      _id: "610c04bbe67cdb30bd4c67d4",
      en: "Absheron",
      ru: "Апшерон",
      model: "city",
      az: "Abşeron",
    },
    corridor: {
      _id: "610c042fe67cdb30bd4c67cb",
      name: {
        _id: "610c042fe67cdb30bd4c67ca",
        en: "Northern",
        ru: "Северный",
        az: "Şimal",
      },
    },
    region: {
      _id: "610c03d0e67cdb30bd4c67bb",
      name: {
        _id: "610c03d0e67cdb30bd4c67ba",
        en: 'Baku-Abseheron: "Harmony of contrasts"',
        ru: "Баку-Абшехерон: «Гармония контрастов»",
        az: 'Bakı-Abşeron: "Təzadlar harmoniyası"',
      },
    },
    createdAt: "2021-08-05T15:33:15.781Z",
  },
];
